import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Router } from "react-router-dom";
import "./App.css";
import { MainAdmin } from "./Pages/adminPanel";
import { bscTable } from "./Pages/bsc";
import { BscWard } from "./Pages/bsc-ward";
import Home from "./Pages/home";
import {
  IndicatorChecklistComponent,
  IndicatorCreateComponent,
  IndicatorDashbaord,
  IndicatorDetailComponent,
  IndicatorIndexComponent,
  IndicatorListComponent,
  SafetyRelatedIndicatorComponent,
} from "./Pages/indicator";
import Login from "./Pages/login";
import { SuperAdminPage, SuperAdminUsersList } from "./Pages/superAdmin";
import { userActions } from "./_actions";
import { Header, PrivateRoute } from "./_components";
import DocumentsCopm from "./_components/Documents.jsx";
import { history } from "./_helpers";
import "./assets/css/all.min.css";
import "./assets/css/animate.css";
import "./assets/css/bootstrap-rtl.min.css";
import loading from "./assets/images/loading.gif";
import "./assets/sass/template.scss";
// import { CommiteResult } from "./Pages/commiteResult";
import { IndicatorCollctorCompact } from "./Pages/indicator/IndicatorCollctorCompact";
import { NewIndicatorCollectorOrMonitor } from "./Pages/indicator/NewIndicatorCollectorOrMonitor";
import { OldIndicatorCollectorOrMonitor } from "./Pages/indicator/OldIndicatorCollectorOrMonitor";
import { LoginAdmin } from "./Pages/loginAdmin";
import { LoginSuperAdmin } from "./Pages/loginSuperAdmin";
import { ManagementOverview } from "./Pages/management-overview";
import {
  IndexEduSuperior,
  IndexEduSupervisor,
  IndexPdp,
  RequestCheckNew,
  RequestCheckSupervisorNew,
  RequestEdu,
  RequestEduStatus,
  RequestEduStatusSuperior,
  RequestEduStatusSupervisor,
  pdpSites,
} from "./Pages/pdpNew";
import { Portal } from "./Pages/portal";
import { UseRedirectToNr } from "./_helpers/redirect-to-nr.jsx";
import UpdateUsers from "./_helpers/updateUsers";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      waitToRender: true,
    };
    axios.defaults.headers.common["Authorization"] =
      this.props.globalStorage.token;
    const { dispatch, globalStorage } = this.props;
    history.listen((location, action) => {
      // clear alert on location change
      /*
            if(location.pathname.indexOf(globalStorage.current_page.location)===-1){
                dispatch(userActions.removeCurrentPage());
            }*/
    });
  }
  async componentDidMount() {
    const search = history.location.search;
    if (search) {
      const params = new URLSearchParams(search);
      if (params) {
        const token = params.get("Token");
        const year = params.get("Year");
        const id = params.get("id");
        if (token) {
          this.props.dispatch(userActions.setToken({ token }));
          await new Promise((r) => setTimeout(r, 2000));
        }
        if (year) {
          this.props.dispatch(userActions.setStorage({ year }));
        }
        if (id) {
          this.props.dispatch(userActions.setTemp(id, "id"));
        }
      }
    }
    this.setState({ waitToRender: false });
  }

  Routes() {
    const { globalStorage } = this.props;
    return !this.state.waitToRender ? (
      <>
        <UseRedirectToNr />
        <Router history={history}>
          <div style={{ minHeight: "100vh" }}>
            <Header history={history} />
            <Route
              path="/updateUsers/:hospital/:password"
              component={UpdateUsers}
            />
            <PrivateRoute path="/" component={Home} exact={true} />
            <Route path="/login" component={Login} exact />
            <Route path="/doc" component={DocumentsCopm} />
            <Route path="/godAdmin" component={LoginSuperAdmin} />
            <Route path="/loginAdmin" component={LoginAdmin} />
            <Route path="/mainAdmin" component={MainAdmin} />
            <Route path="/superAdmin" component={SuperAdminPage} exact />
            <Route
              path="/superAdmin/users/:hospital_id"
              component={SuperAdminUsersList}
              exact
            />
            <PrivateRoute
              path="/indicator/collector/bsc-ward"
              component={BscWard}
              exact
            />
            <Route path="/portal/:id" component={Portal} />
            <PrivateRoute
              path="/pdp/indexEduSuperior"
              component={IndexEduSuperior}
              exact
            />
            <PrivateRoute
              path="/pdp/indexEduSupervisor"
              component={IndexEduSupervisor}
              exact
            />
            <PrivateRoute path="/pdp" component={IndexPdp} exact />
            <PrivateRoute path="/pdpSites" component={pdpSites} exact />
            <PrivateRoute path="/pdp/requestEdu" component={RequestEdu} exact />
            <PrivateRoute
              path="/pdp/superior/requestEduStatus"
              component={RequestEduStatusSuperior}
              exact
            />
            <PrivateRoute
              path="/pdp/supervisor/requestEduStatus"
              component={RequestEduStatusSupervisor}
              exact
            />
            <PrivateRoute
              path="/pdp/requestEduStatus"
              component={RequestEduStatus}
              exact
            />
            <PrivateRoute
              path="/pdp/requestCheck"
              component={RequestCheckNew}
              exact
            />
            <PrivateRoute
              path="/pdp/supervisor/requestCheck"
              component={RequestCheckSupervisorNew}
              exact
            />
            <PrivateRoute path="/bsc" component={bscTable} exact />
            {/*<PrivateRoute path="/commiteResult" component={CommiteResult} exact />*/}
            <PrivateRoute
              path="/indicator"
              component={IndicatorIndexComponent}
              exact
            />
            <PrivateRoute
              path="/indicator/safety_related"
              component={SafetyRelatedIndicatorComponent}
              exact
            />
            <PrivateRoute
              path="/indicator/dashboard"
              component={IndicatorDashbaord}
              exact
            />
            <PrivateRoute
              path="/indicator/monitor"
              component={OldIndicatorCollectorOrMonitor}
              exact
            />
            <PrivateRoute
              path="/indicator/collector"
              component={NewIndicatorCollectorOrMonitor}
              exact
            />
            <PrivateRoute
              path="/indicator/collector/compact"
              component={IndicatorCollctorCompact}
              exact
            />
            <PrivateRoute
              path="/indicator/list"
              component={IndicatorListComponent}
              exact
            />
            <PrivateRoute
              path="/indicator/list/detail/:id"
              component={IndicatorDetailComponent}
              exact
            />
            <PrivateRoute
              path="/indicator/list/create"
              component={IndicatorCreateComponent}
              exact
            />
            <PrivateRoute
              path="/indicator/list/edit/:id"
              component={IndicatorCreateComponent}
              exact
            />
            <PrivateRoute
              path="/indicator/list/checklist/:id"
              component={IndicatorChecklistComponent}
              exact
            />
            <PrivateRoute
              path="/ManagementOverview"
              component={ManagementOverview}
              exact
            />
            {globalStorage && globalStorage.loading > 0 && (
              <div
                className="loading_req position-fixed bg-white w-100 h-100 zoomIn"
                style={{ top: 0, left: 0, zIndex: 99999 }}
              >
                <img
                  src={loading}
                  alt="در حال دریافت اطلاعات..."
                  className="position-absolute m-auto loading"
                  style={{ left: 0, right: 0, top: 0, bottom: 0 }}
                />
              </div>
            )}
          </div>
          <div className="wave">
            <button
              onClick={() => {
                window.scrollTo(0, 0);
              }}
              className="btn btn-link mx-auto d-block"
            >
              <i
                className="fal fa-chevron-up  circle"
                style={{
                  background: "#104c82",
                  padding: "10px",
                  color: "#ffffff",
                }}
              />
            </button>
            <p className="text-center" style={{ fontSize: "0.8em" }}>
              تمام حقوق نرم افزار سنجاب متعلق به
              <a
                href="https://noavaran-sharif.ir"
                className="px-1 text-center"
                style={{ color: "#104c82" }}
              >
                {" "}
                نـوآوران سلامت گستر شریف{" "}
              </a>
              است
            </p>
          </div>
        </Router>
      </>
    ) : (
      <div
        className="loading_req position-fixed bg-white w-100 h-100 zoomIn"
        style={{ top: 0, left: 0, zIndex: 99999 }}
      >
        <img
          src={loading}
          alt="در حال دریافت اطلاعات"
          className="position-absolute m-auto loading"
          style={{ left: 0, right: 0, top: 0, bottom: 0 }}
        />
      </div>
    );
  }

  render() {
    return this.Routes();
  }
}
function mapStateToProps(state) {
  const { globalStorage } = state;
  return {
    globalStorage,
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
